import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  label: {
    color: colors.white,
    fontSize: 36,
    fontWeight: 600,
    margin: "0 0 18px 0",
    position: "relative",
    [Commons.smallQuery]: {
      fontSize: 20,
    },
  },
  moreButton: {
    textDecoration: "none",
    "& div": {
      ...Commons.defaultButton,
      color: colors.white,
      backgroundColor: colors.primary,
      borderRadius: 18,
      padding: "6px 18px",
      fontWeight: 700,
    },
  },
  containerListPlayer: {
    position: "relative",
    width: "100%",
    gap: 60,
    [Commons.smallQuery]: {
      gap: 18,
    },
  },
  itemPlayer: {
    width: "calc((100% / 3) - 40px)",
    [Commons.smallQuery]: {
      width: "calc((100% / 2) - 12px)",
    },
  },
  itemImgPlayer: {
    aspectRatio: "2 / 1",
    position: "relative",
    borderRadius: 18,
    boxShadow: `0 0 30px 10px ${colors.orange}30`,
    overflow: "hidden",
    width: "100%",
    cursor: "pointer",
  },
  itemNamePlayer: {
    color: colors.white,
    margin: "12px 0 6px 0",
    fontSize: 18,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  itemDescriptionPlayer: {
    color: colors.white,
    margin: 0,
    fontSize: 18,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    [Commons.smallQuery]: {
      fontSize: 16,
    },
  },
  iconPlayer: {
    position: "absolute",
    width: 90,
    height: 90,
    [Commons.smallQuery]: {
      width: 60,
      height: 60,
    },
  },
  imageVideo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  newBadge: {
    position: "absolute",
    top: 12,
    left: 12,
    backgroundColor: colors.primary,
    color: colors.white,
    borderRadius: 12,
    padding: "6px 12px",
    fontSize: 18,
    boxShadow: colors.shadowWhite,
    fontWeight: 600,
    [Commons.smallQuery]: {
      fontSize: 12,
    },
  },
});

export default styles;
